export const CLASS_ICONS: Record<string, string> = {
  Warrior: "/icons/class/warrior.webp",
  Paladin: "/icons/class/paladin.webp",
  Hunter: "/icons/class/hunter.webp",
  Rogue: "/icons/class/rogue.webp",
  Priest: "/icons/class/priest.webp",
  Shaman: "/icons/class/shaman.webp",
  Mage: "/icons/class/mage.webp",
  Warlock: "/icons/class/warlock.webp",
  Druid: "/icons/class/druid.webp",
};

export const RACE_ICONS: Record<string, string> = {
  Human: "/icons/race/human.webp",
  Orc: "/icons/race/orc.webp",
  "Night Elf": "/icons/race/nightelf.webp",
  Undead: "/icons/race/undead.webp",
  Tauren: "/icons/race/tauren.webp",
  Gnome: "/icons/race/gnome.webp",
  Troll: "/icons/race/troll.webp",
  Dwarf: "/icons/race/dwarf.webp",
  Goblin: "/icons/race/goblin.webp",
};

export const FACTION_ICONS: Record<string, string> = {
  Alliance: "/icons/alliance.webp",
  Horde: "/icons/horde.webp",
};

export const CURRENCY_ICONS: Record<string, string> = {
  Copper: "/icons/currency/copper.webp",
  Silver: "/icons/currency/silver.webp",
  Gold: "/icons/currency/gold.webp",
};

export const TALENT_ICONS: Record<number, string> = {
  1382: "spell_nature_ravenform",
  1342: "spell_frost_wizardmark",
  1343: "ability_hunter_snipershot",
  1344: "ability_searingarrow",
  1345: "inv_spear_07",
  1352: "ability_townwatch",
  1349: "ability_piercedamage",
  1353: "ability_golemstormbolt",
  1347: "ability_upgrademoonglaive",
  1362: "inv_weapon_rifle_06",
  1361: "ability_trueshot",
  1623: "inv_misc_head_dragon_black",
  1301: "spell_holy_prayerofhealing",
  1311: "ability_parry",
  1621: "ability_racial_bloodrage",
  1622: "spell_shadow_twilight",
  1308: "ability_whirlwind",
  1310: "ability_kick",
};

export const LEVEL_XP_MAP: Record<number, number> = {
  1: 400,
  2: 900,
  3: 1400,
  4: 2100,
  5: 2800,
  6: 3600,
  7: 4500,
  8: 5400,
  9: 6500,
  10: 7600,
  11: 8800,
  12: 10100,
  13: 11400,
  14: 12900,
  15: 14400,
  16: 16000,
  17: 17700,
  18: 19400,
  19: 21300,
  20: 23200,
  21: 25200,
  22: 27300,
  23: 29400,
  24: 31700,
  25: 34000,
  26: 36400,
  27: 38900,
  28: 41400,
  29: 44300,
  30: 47400,
  31: 50800,
  32: 54500,
  33: 58600,
  34: 62800,
  35: 67100,
  36: 71600,
  37: 76100,
  38: 80800,
  39: 85700,
  40: 90700,
  41: 95800,
  42: 101000,
  43: 106300,
  44: 111800,
  45: 117500,
  46: 123200,
  47: 129100,
  48: 135100,
  49: 141200,
  50: 147500,
  51: 153900,
  52: 160400,
  53: 167100,
  54: 173900,
  55: 180800,
  56: 187900,
  57: 195000,
  58: 202300,
  59: 209800,
  60: 217400,
};
